var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hzw-slider"},[_c('div',{staticClass:"hzw-list"},[_c('div',{ref:"slickTrack",staticClass:"hzw-track",style:({width:`${_vm.slickTrackWidth}px`,transform:`translate3d(${_vm.transformX}px, 0px, 0px)`})},[_vm._t("default")],2),_vm._t("dots")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }